import React from 'react'

export const CandidateDetailCard = ({ children }) => {
  return (
    <div className="w-full p-8 mb-8 bg-white shadow-lg lg:p-12">{children}</div>
  )
}
